import { AppData } from '..';
import { makeAddonsStr } from './common-functions';
import MetaEventLogger from '../../shared/utils/metaEventLogger';
import { FirebaseService } from "src/app/shared/services/firebase.service";


export function appStartedCleverTabObj(event) {
    const body = {
        // start_code: errorResponse.code,
        // message: errorResponse.message,
        eventName: event
    }

    return Object.assign(body, localityAndCityCleverTabObj());
}

export function localityAndCityCleverTabObj() {
    const body = {
        userId: AppData.userId ? AppData.userId : '',
    }
    if (AppData.currentAddressObj) {
        body['userCity'] = AppData.currentAddressObj.city
        body['userLocality'] = AppData.currentAddressObj.locality ? AppData.currentAddressObj.locality : (AppData.currentAddressObj.googleLocation ? AppData.currentAddressObj.googleLocation : AppData.currentAddressObj.city)
        body['coordinates'] = AppData.currentAddressObj.longLat.coordinates
        // if (AppData.currentAddressObj.locality) {
        //     body['userLocality'] = AppData.currentAddressObj.locality;
        // } else if (AppData.currentAddressObj.googleLocation) {
        //     body['userLocality'] = AppData.currentAddressObj.googleLocation;
        // } else {
        //     body['userLocality'] = AppData.currentAddressObj.city;
        // }
    } else {
        body['userCity'] = '';
        body['userLocality'] = '';
    }
    return body;
}

export function cartClickedevent() {
    const body = {
        cartId: AppData.cartId,
        outletId: AppData.yourPlateItems['outlets'][0]['outletId'],
        outletLocality: AppData.yourPlateItems['outlets'][0]['locality'],
        outletCity: AppData.yourPlateItems['outlets'][0]['outletAddress']['city'],
        outletName: AppData.yourPlateItems['outlets'][0]['outletName'],
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function addItemInCartCleverTapObj(obj, locality) {
    const body = {
        outletId: obj.outletId,
        outletName: obj.outletName,
        itemId: obj.itemId,
        itemName: obj.name,
        outletLocality: locality,
        discountedPrice: obj.price,
        itemPrice: obj.originalPrice ? obj.originalPrice : obj.price,
        cartId: AppData.cartId,
        outletCity: AppData.currentAddressObj ? AppData.currentAddressObj.city : '',
        categoryId: obj.category,
        subCategoryId: obj.subCategory ? obj.subCategory : '',
        promoId: obj.promoId ? obj.promoId : ''


        // quantity: quantity,
        // addon: obj.addons.length > 0 ? makeAddonsStr(obj.addons) : '',
        // variant: obj.variant ? obj.variant.options.optionName : ''
    }
    return Object.assign(body, localityAndCityCleverTabObj());
}


export function removeItemInCartCleverTapObj(obj) {
    const body = {
        outletId: obj.outletId,
        outletName: obj.outletName,
        itemId: obj.itemId,
        itemName: obj.name,
        itemPrice: obj.originalPrice ? obj.originalPrice : obj.price,
        discountedPrice: obj.price,
        outletLocality: AppData.yourPlateItems.outlets[0].locality,
        cartId: AppData.cartId,
        outletCity: AppData.currentAddressObj ? AppData.currentAddressObj.city : '',
        categoryId: obj.category,
        subCategoryId: obj.subCategory ? obj.subCategory : '',
        promoId: obj.promoId ? obj.promoId : ''
    }

    return Object.assign(body, localityAndCityCleverTabObj());
}

export function clearCartAnalyticObj(cartObj) {
    return Object.assign(cartObj, localityAndCityCleverTabObj());
}

export function userInfoCleverTapEventObj() {
    const body = {
        userFirstName: AppData.userInfoData.name,
        userLastName: AppData.userInfoData.lastName,
        userEmailAddress: AppData.userInfoData.email,
        userMobileNumber: AppData.userInfoData.mobile
    }
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function paymentSuccessObj(orderId, outletId, preCheckoutData) {
    const body = {
        orderId: orderId,
        outletId: outletId,
        timestamp: new Date().toISOString(),
        outletCity: preCheckoutData.outlets[0].outletAddress.city,
        couponId: preCheckoutData.coupons.length > 0 ? preCheckoutData.coupons[0].couponId : '',
        outletLocality: preCheckoutData.outlets[0].locality,
        outletName: preCheckoutData.outlets[0].outletName,
    }
    console.log(body, localityAndCityCleverTabObj());

    return Object.assign(body, localityAndCityCleverTabObj());
}

export function paymentFailedObj(orderId, outletId, preCheckoutData) {
    const body = {
        orderId: orderId,
        outletId: outletId,
        timestamp: new Date().toISOString(),
        outletCity: preCheckoutData.outlets[0].outletAddress.city,
        couponId: preCheckoutData.coupons.length > 0 ? preCheckoutData.coupons[0].couponId : '',
        outletLocality: preCheckoutData.outlets[0].locality,
        outletName: preCheckoutData.outlets[0].outletName,
    }
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function couponAppliedCleverTapEventObj(billingObj, preCheckoutData) {
    const body = {
        couponCode: preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['code'] : '',
        couponAmount: preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['value'] : '',
        amountSaved: preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['couponDiscount'] : '',
        discountedPrice: billingObj.totalAmount + (preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['couponDiscount'] : 0),
        outletId: preCheckoutData['cartDoc']['outlets'][0]['outletId'],
        cartValue: billingObj.totalAmount,
        couponType: preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['discountType'] : '',
        cartId: preCheckoutData['cartDoc']['cartId'],
        couponId: preCheckoutData.cartDoc.coupons.length > 0 ? preCheckoutData.cartDoc.coupons[0].couponId : '',
        outletName: preCheckoutData.cartDoc.outlets[0].outletName,
        outletLocality: preCheckoutData.cartDoc.outlets[0].locality,
        outletCity: preCheckoutData['cartDoc']['outlets'][0]['outletAddress']['city'],


    }
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function removeCouponCleverTapEventObj(billingObj, preCheckoutData) {
    const body = {
        couponCode: preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['code'] : '',
        couponAmount: preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['value'] : '',
        amountSaved: preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['couponDiscount'] : '',
        discountedPrice: billingObj.totalAmount + (preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['couponDiscount'] : 0),
        outletId: preCheckoutData['cartDoc']['outlets'][0]['outletId'],
        cartValue: billingObj.totalAmount,
        couponType: preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['discountType'] : '',
        cartId: preCheckoutData['cartDoc']['cartId'],
        outletCity: preCheckoutData['cartDoc']['outlets'][0]['outletAddress']['city'],
        couponId: preCheckoutData.cartDoc.coupons.length > 0 ? preCheckoutData.cartDoc.coupons[0].couponId : '',
        outletName: preCheckoutData.cartDoc.outlets[0].outletName,
        outletLocality: preCheckoutData.cartDoc.outlets[0].locality,
    }
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function unableToCheckoutCleverTapEventObj(outletId, errorMsg, errorCode) {
    const body = {
        outletId: outletId,
        cartId: AppData.cartId,
        failureReason: errorMsg,
        failureCode: errorCode
    }
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function paymentSuccessFailedCleverTapEvent(orderId, outletId) {
    const body = {
        orderId: orderId,
        outletId: outletId,
        cartId: AppData.cartId,
    }
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function paymentInitiatedCleverTapEventObj(billingObj, preCheckoutData) {
    const body = {
        outletName: preCheckoutData['cartDoc']['outlets'][0]['outletName'],
        outletId: preCheckoutData['cartDoc']['outlets'][0]['outletId'],
        noOfItems: preCheckoutData['cartDoc']['outlets'][0]['items'].length,
        discount: billingObj.discount,
        deliveryPrice: preCheckoutData['deliveryInfo']['deliveryCharge'],
        savings: billingObj.discount,
        totalPrice: billingObj.totalAmount,
        couponApplied: preCheckoutData['cartDoc']['coupons'].length > 0 ? 'Y' : 'N',
        couponAmount: preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['value'] : '',
        cartId: preCheckoutData['cartDoc']['cartId'],
        couponType: preCheckoutData['cartDoc']['coupons'].length > 0 ? preCheckoutData['cartDoc']['coupons'][0]['discountType'] : '',
        gst: billingObj['taxes'][0]['value']
    }
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function seeMoreCleverTapEventObj(obj) {
    const body = {
        sectionName: obj.heading,
        sectionId: obj.sectionId,
        layoutId: obj.layoutType,
        promoId: obj['list'][0]['promoId'],
        promoName: obj.title,
        displayOrderSeq: obj.displayOrderSeq
    }

    return Object.assign(body, localityAndCityCleverTabObj());
}

export function promoClickCleverTapEvent(obj) {
    const body = {
        sectionName: obj.heading,
        sectionId: obj.sectionId,
        layoutId: obj.layoutType,
        promoId: obj.promoId,
        promoName: obj.title,
        displayOrderSeq: obj.displayOrderSeq
    }

    return Object.assign(body, localityAndCityCleverTabObj());
}

export function couponPageVisited(outletId, couponIds) {
    const outletObj = AppData.yourPlateItems.outlets[0];
    const body = {
        outletId: outletId,
        outletName: outletObj.outletName,
        outletCity: outletObj.outletAddress.city,
        outletLocality: outletObj.locality,
        coordinates: outletObj.location.coordinates,
        cartId: AppData.cartId,
        couponIds: couponIds
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function payClickedEvent(obj, outletObj) {
    const body = {
        cartId: AppData.cartId,
        cartValue: AppData.yourPlateItems.billing.totalAmount,
        orderId: obj['orderId'],
        outletId: outletObj['outletId'],
        outletLocality: outletObj['locality'],
        outletName: outletObj['outletName'],
        outletCity: AppData.currentAddressObj ? AppData.currentAddressObj.city : ''
    }

    return Object.assign(body, localityAndCityCleverTabObj())

}

export function upiAppClicked(obj) {
    const body = {
        url: obj.url,
        package: obj.packageName,
        status: obj.status
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function appExitedObj() {
    const body = {
    }
    return Object.assign(body, localityAndCityCleverTabObj());

}

export function appInForegroundEvent() {
    const body = {}
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function appInBackgroundEvent() {
    const body = {}
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function topBannerClickObj(bannerObj, firebaseService: FirebaseService) {
    const coords = AppData.currentAddressObj?.longLat?.coordinates || [];
    const params = {
        app_name: 'yumzy-ios',
        timestamp: Number(Date.now()),
        client: 'iOS',
        promo_id: String(bannerObj.promoId || ""),
        promo_name: String(bannerObj.title || ""),
        section_name: String(bannerObj.heading || ""),
        layout_id: String(bannerObj.layoutType || ""),
        display_order_seq: Number(bannerObj.displayOrderSeq || 0),

        user_id: String(AppData.userId || ""),
        user_city: String(AppData.currentAddressObj?.city || ""),
        user_locality: String(AppData.currentAddressObj?.locality || ""),

        // Flatten coordinates for Meta + GA4
        latitude: coords[1] || 0,
        longitude: coords[0] || 0
    };
    MetaEventLogger.bannerClick(params);
    firebaseService.logCustomEvent("top_banner_click", params);
    
    const body = {
        promoId: bannerObj.promoId,
        promoName: bannerObj.title,
        sectionName: bannerObj.heading,
        sectionId: bannerObj.sectionId,
        layoutId: bannerObj.layoutType,
        displayOrderSeq: bannerObj.displayOrderSeq
    }
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function topBannerimpressionObj(bannerObj, bannerPosition) {
    const body = {
        promoId: bannerObj.promoId,
        promoName: bannerObj.title,
        sectionName: bannerObj.heading,
        sectionId: bannerObj.sectionId,
        layoutId: bannerObj.layoutType,
        displayOrderSeq: bannerObj.displayOrderSeq,
        bannerPosition: bannerPosition
    }
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function outletViewedObj(outletObj, promoId) {
    const body = {
        outletId: outletObj.outletId,
        outletName: outletObj.outletName,
        outletLocality: outletObj.locality,
        outletCity: AppData.currentAddressObj ? AppData.currentAddressObj.city : '',
        timestamp: new Date().toISOString(),
        promoId: promoId || ''
    }

    return Object.assign(body, localityAndCityCleverTabObj());
}

export function outletExited(outletObj, promoId) {
    const body = {
        outletId: outletObj.outletId,
        outletName: outletObj.outletName,
        outletLocality: outletObj.locality,
        outletCity: AppData.currentAddressObj ? AppData.currentAddressObj.city : '',
        timestamp: new Date().toISOString(),
        promoId: promoId || ''
    }

    return Object.assign(body, localityAndCityCleverTabObj());
}

export function onChangeOutletEvent(outletObj) {
    const body = {
        outletId: outletObj.outletId,
        outletName: outletObj.outletName,
        outletLocality: outletObj.locality,
        outletCity: AppData.currentAddressObj ? AppData.currentAddressObj.city : '',
    }

    return Object.assign(body, localityAndCityCleverTabObj());
}

export function letsExploreEvent() {
    const body = {

    }
    return Object.assign(localityAndCityCleverTabObj())
}

export function vegToggleEvent(obj, vegToggled) {
    const body = {
        outletId: obj.outletId,
        outletLocality: obj.locality,
        outletName: obj.outletName,
        vegToggled: vegToggled
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function categoryClickedEvent(obj) {
    const body = {
        outletId: obj.outletId,
        outletLocality: obj.locality,
        outletName: obj.outletName
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function subCategoryClicked(obj) {
    const body = {
        outletId: obj.outletId,
        outletLocality: obj.locality,
        outletName: obj.outletName
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function searchMenuItemsEvent(searchValue, outletObj, fetchedItems) {
    const body = {
        searchMenuItemName: searchValue,
        cartId: AppData.cartId,
        outletId: outletObj.outletId,
        outletName: outletObj.outletName,
        outletLocality: outletObj.locality,
        fetchedMenuItems: fetchedItems
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function searchRestaurantsOrFood(searchValue, searchResultObj) {
    const body = {
        userFirstName: AppData.userInfoData ? AppData.userInfoData.name : '',
        userLastName: AppData.userInfoData ? AppData.userInfoData.lastName : '',
        userEmail: AppData.userInfoData ? AppData.userInfoData.email : '',
        userMobileNumber: AppData.userInfoData ? AppData.userInfoData.mobile : '',
        searchMenuItemName: searchValue,
        fetchedDishes: searchResultObj.itemIds,
        fetchedRestaurant: searchResultObj.outletIds
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function manageAddressEvent() {
    const body = {
        // outletId: AppData.selectedOutlet.outletId,
        // outletLocality: AppData.selectedOutlet.locality,
        // outletName: AppData.selectedOutlet.outletName
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function userChangeLocation(manualOrGPS) {
    const body = {
        manualOrGPS: manualOrGPS
    }
    return Object.assign(body, localityAndCityCleverTabObj());
}

export function userWalletEvent(balance) {
    const body = {
        walletBalance: balance
    }
    return Object.assign(body, localityAndCityCleverTabObj())

}

export function orderHistoryEvent() {
    const body = {
        // outletId: AppData.selectedOutlet.outletId,
        // outletLocality: AppData.selectedOutlet.locality,
        // outletName: AppData.selectedOutlet.outletName
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}
export function myRewardsEvent() {
    const body = {
        // outletId: AppData.selectedOutlet.outletId,
        // outletLocality: AppData.selectedOutlet.locality,
        // outletName: AppData.selectedOutlet.outletName
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function sendOtpToUser(reqBody) {
    const body = {
        userMobileNumber: reqBody.mobile,
        method: reqBody.method ? reqBody.method : 'sendOtp',
        type: reqBody.action,
        countryCode: reqBody.countryCode
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function userSignUpEvent(referralCode) {
    const body = {
        userFirstName: AppData.userInfoData.name,
        userLastName: AppData.userInfoData.lastName,
        userEmail: AppData.userInfoData.email,
        userMobileNumber: AppData.userInfoData.mobile,
        referralCode: referralCode
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function onNotificationClickedEvent(notificationData) {
    const body = {
        userFirstName: AppData.userInfoData ? AppData.userInfoData.name : '',
        userLastName: AppData.userInfoData ? AppData.userInfoData.lastName : '',
        userEmail: AppData.userInfoData ? AppData.userInfoData.email : '',
        userMobileNumber: AppData.userInfoData ? AppData.userInfoData.mobile : '',
        isNotificationClicked: true,
        isTemporary: AppData.isTemporary,
        campaignData: notificationData.data ? JSON.parse(notificationData.data) : processNotifsData(notificationData),
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

function processNotifsData(notificationData) {
    Object.keys(notificationData).forEach((key) => {
        if ((key.indexOf('google') > -1) || (key.indexOf('gcm') > -1)) {
            delete notificationData[key];
        }
    });
    return notificationData;
}

export function allowBlockNotificationEvent(allowNotification) {
    const body = {
        isNotificationAllowed: allowNotification,
        userFirstName: AppData.userInfoData ? AppData.userInfoData.name : '',
        userLastName: AppData.userInfoData ? AppData.userInfoData.lastName : '',
        userEmail: AppData.userInfoData ? AppData.userInfoData.email : '',
        userMobileNumber: AppData.userInfoData ? AppData.userInfoData.mobile : '',
    }
    return Object.assign(body, localityAndCityCleverTabObj())
}

export function inviteClicked(referralCode, contactsAuthorized) {
    const body = {
        referralCode: referralCode,
        contactsPermissionGranted: contactsAuthorized
    }

    return Object.assign(body, localityAndCityCleverTabObj());
}

export function appErrorEventObj(reqBody, errorObj) {
    const body = {
        userFirstName: AppData.userInfoData ? AppData.userInfoData.name : '',
        userLastName: AppData.userInfoData ? AppData.userInfoData.lastName : '',
        userEmail: AppData.userInfoData ? AppData.userInfoData.email : '',
        userMobileNumber: AppData.userInfoData ? AppData.userInfoData.mobile : '',
        errorResponse: errorObj,
        isTemporary: AppData.isTemporary,
    }
    Object.assign(body, reqBody);
    console.log(body)
    return Object.assign(body, localityAndCityCleverTabObj());
}

